import { startDoctorSession } from "./middleware-api.js";
import { requireLogin } from "./account-login-modal.js";

document.addEventListener("DOMContentLoaded", function () {
  // Attach click event to all .speak-to-doctor-btn buttons
  document.querySelectorAll(".speak-to-doctor-btn").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      // Uncomment here to block epharmency
      // const modal = document.getElementById('doctor-error-modal');
      // const modalMsg = document.getElementById('modal-message');
      // modalMsg.textContent = "Sorry doctor is not available.";
      // modal.classList.remove('hidden');

      // modal.querySelector('.modal-close').addEventListener('click', () => {
      //   modal.classList.add('hidden');
      // });

      // modal.addEventListener('click', (e) => {
      //   if (e.target === modal) modal.classList.add('hidden');
      // });

      // Uncomment here to enable epharmency
      const variantId = btn.dataset.variantId;

      if (!variantId) {
        alert("Missing variant ID.");
        return;
      }

      requireLogin(() => startEPharmacySession(variantId));
    });
  });

  // API call to start e-pharmacy session
  async function startEPharmacySession(variantId) {
    try {
      const res = await startDoctorSession(variantId);

      if (res?.doc2usResponse?.RedirectURL) {
        window.location.href = res.doc2usResponse.RedirectURL;
      } else {
        showToast("Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error starting ePharmacy session:", error);

      const message = error?.error?.message || error?.message || "";

      const modal = document.getElementById('doctor-error-modal');
      const modalMsg = document.getElementById('modal-message');
      const modalAction = document.getElementById('doctor-action-link');
      if (message.toLowerCase().includes("user profile is incomplete")) {
        modalMsg.textContent = "User Profile is incomplete. Please complete your profile details";
        modalAction.textContent = "Complete profile now";
        modalAction.href = "/account?p=edit";
      }
      else {
        modalMsg.textContent = "Failed to start medication approval. Please try again later";
        modalAction.textContent = "";
      }
      
      modal.classList.remove('hidden');

      modal.querySelector('.modal-close').addEventListener('click', () => {
        modal.classList.add('hidden');
      });

      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.classList.add('hidden');
      });
    }
  }

});
